import React from 'react';
import s from './Armchair.module.css';
import Ribbon from '../../components/Ribbon/Ribbon';
import ProductCard from '../../components/ProductCard/ProductCard';
import armchair from '../../JSON/armchair.json';
import ProductCardHero from '../../components/ProductCardHero/ProductCardHero';
import Container from '../../components/Container/Container';

export default function Mice() {
  return (
    <div className={s.ProductsPage}>
      <ProductCardHero
        text={'Крісла GamePro для дому та офісу – усе для вашого комфорту'}
        title={armchair[0].title}
        sendUrl={'/Images/ProductCardHeroBackgroundImages/armchair.png'}
      />
      <Ribbon />
      <Container>
        <div className={s.ProductsListDescription}>
          <h2 className={s.ProductsPageTitle}>Геймерські крісла</h2>
          <p className={s.ProductsPageText}>
            Якісна клавіатура життєво необхідна як для роботи, так і для
            відпочинку. Незалежно від того, чи є ви механічним пуристом,
            любителем гри на дивані, фанатом додаткових функцій або тим, хто
            хоче всього цього, - у нас є все необхідне.
          </p>
        </div>

        <div className={s.ProductsList}>
          <ProductCard products={armchair} />
        </div>
      </Container>
    </div>
  );
}
